import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Select } from 'antd';
import type { TFunction } from 'i18next';
import { citiesByCountry, COUNTRY_OPTIONS } from '../../constants/countries';

const { Option } = Select;

const COUNTRY_LABEL_BY_VALUE: Record<string, string> = {
  US: 'United States',
  GB: 'United Kingdom',
  AU: 'Australia',
  IN: 'India',
  CL: 'Chile',
  BR: 'Brazil',
};

interface LocationFormSectionProps {
  t: TFunction;
  citiesByCountryMap?: Record<string, string[]>;
}

/**
 * Country and region (city) dropdowns for Register flow.
 * Adapted from internal-web LocationFormSection (add new lead modal).
 */
const LocationFormSection: React.FC<LocationFormSectionProps> = ({
  t,
  citiesByCountryMap = citiesByCountry,
}) => {
  const form = Form.useFormInstance();
  const selectedCountry = Form.useWatch('country', form) ?? 'CL';
  const [cityOptions, setCityOptions] = useState<string[]>(
    citiesByCountryMap['Chile'] ?? []
  );

  useEffect(() => {
    const countryLabel = COUNTRY_LABEL_BY_VALUE[selectedCountry] ?? 'Chile';
    setCityOptions(citiesByCountryMap[countryLabel] ?? []);
    form.setFieldValue('region', undefined);
  }, [selectedCountry, citiesByCountryMap, form]);

  return (
    <Row gutter={16}>
      <Col xs={24} sm={12}>
        <Form.Item
          name="country"
          label={t('auth:country')}
          rules={[{ required: true, message: t('auth:countryRequired') }]}
        >
          <Select placeholder={t('auth:countryPlaceholder')}>
            {COUNTRY_OPTIONS.map((c) => (
              <Option key={c.value} value={c.value}>
                {c.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item
          name="region"
          label={t('auth:region')}
          rules={[{ required: true, message: t('auth:regionRequired') }]}
        >
          <Select placeholder={t('auth:regionPlaceholder')} allowClear>
            {cityOptions.map((city) => (
              <Option key={city} value={city}>
                {city}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default LocationFormSection;
